/* global bz_app, Track, angular, UserAPI */
bz_app.directive('claimPropertyButton', [
  'propertyModel',
  'userService',
  function (propertyModel, userService) {
    return {
      restrict: 'AE',
      scope: {
        propertyId: '@',
        userId: '@',
      },
      link: function (scope, element, attrs) {
        element.click(function (e) {
          scope.trackPropertyClaimButtonClick(scope.userId ? 'existing' : 'new')

          if (scope.userId) {
            scope.claim('existing')
          } else {
            scope.register()
          }

          e.preventDefault()
        })

        scope.claim = function (userSource) {
          return userService.status().then(function (response) {
            // need to check status to refresh/set CSRF token from back-end
            if (userService.logged_in(response)) {
              propertyModel
                .claim(scope.propertyId, scope.userId)
                .then(function (response) {
                  if (response && response.success) {
                    scope.trackPropertyClaimAction(userSource)
                    element
                      .hide()
                      .after(
                        '<div class="this-is-my-property-confirmation pull-center">Thank you for claiming your property!</div>'
                      )
                  }
                })
            } else {
              scope.register()
            }
          })
        }

        scope.register = function () {
          var postRegistrationCallback = function () {
            scope.claim('new').then(scope.refreshPage)
          }

          var loggedInCallback = function (response) {
            scope.userId = response.user_id
            scope.claim('new').then(scope.refreshPage)
          }

          userService.show_sign_up_modal(
            'property_claimed_by_user',
            postRegistrationCallback,
            loggedInCallback
          )
        }

        scope.refreshPage = function () {
          /* eslint-disable */
          document.location = document.location
          /* eslint-enable */
        }

        scope.trackPropertyClaimButtonClick = function (userSource) {
          Track.send('Property Action', {
            action: 'claim button click',
            property_id: scope.propertyId,
            user_id: scope.userId,
            user_source: userSource,
          })
        }

        scope.trackPropertyClaimAction = function (userSource) {
          Track.send('Property Action', {
            action: 'claim completed',
            property_id: scope.propertyId,
            user_id: scope.userId,
            user_source: userSource,
          })
        }
      },
    }
  },
])
